import { styled } from '../../system';
export const Box = styled('div', {});
Box.displayName = 'Box';
